<div *ngIf="initialized" class="card">
  <!-- Header -->
  <header class="card-header bg-light py-3 px-5">
    <div class="d-flex justify-content-between align-items-center">
      <div>
        <h3 class="d-block h6 mb-0">Super User Tools  {{ event.startTime | date: 'shortTime' }} - {{ event.endTime | date: 'shortTime' }}</h3>
        <h4 class="h6 mb-0 d-block">CEUs:  {{ event.ceus |ceuDisplay }}</h4>
      </div>
      <button type="button" class="close" aria-label="Close" (click)="close()">
        <span aria-hidden="true">×</span>
      </button>
    </div>
  </header>
  <!-- End Header -->

  <!-- Body -->

  <div #questionContainer class="card-body" style="">
    <div class="participant-list" style="">
      <div>
        <div class="row">
          <div class="col-md-12">
            <span *ngIf="videoHealthData.length > 0"> Stream Health: <i class="fas fa-circle txt-danger" [ngClass]="{ 'text-success': videoHealthData[videoHealthData.length - 1].healthy, 'text-danger': !videoHealthData[videoHealthData.length - 1].healthy }"></i></span>
          </div>
          <div class="col-md-12">
            <span *ngIf="videoHealthData.length > 0"
            >Video Bitrate: <strong>{{ videoHealthData[videoHealthData.length - 1].incomingBitrate | bytes }}/s</strong>
            </span>
          </div>
          <div class="col-md-12">
            <span *ngIf="audioHealthData.length > 0"
            >Audio Bitrate: <strong>{{ audioHealthData[audioHealthData.length - 1].incomingBitrate | bytes }}/s</strong>
            </span>
          </div>
          <div class="col-md-12">
            <a href="javascript:void(0)" (click)="showGraph = !showGraph">Toggle Graph</a>
          </div>
          <div class="col-md-12" *ngIf="showGraph">
            <kendo-chart>
              <kendo-chart-title text="Stream Health"></kendo-chart-title>
              <kendo-chart-legend position="bottom" orientation="horizontal"></kendo-chart-legend>

              <kendo-chart-value-axis>
                <kendo-chart-value-axis-item [min]="0" [max]="maxValue">
                  <kendo-chart-value-axis-item-labels [content]="contentString"></kendo-chart-value-axis-item-labels>
                </kendo-chart-value-axis-item>
              </kendo-chart-value-axis>
              <kendo-chart-series>
                <kendo-chart-series-item type="line" [data]="array$ | async" field="incomingBitrate" [name]="'Video Health'">
                  <kendo-chart-series-item-tooltip>
                    <ng-template let-value="value">
                      {{ value | bytes }}
                    </ng-template>
                  </kendo-chart-series-item-tooltip>
                  <kendo-chart-series-defaults-labels></kendo-chart-series-defaults-labels>
                </kendo-chart-series-item>
              </kendo-chart-series>
            </kendo-chart>
          </div>
          <!-- <kendo-chart>
            <kendo-chart-series>
                <kendo-chart-series-item [data]="[1, 4, 5, 2, 1, 8]"> </kendo-chart-series-item>
            </kendo-chart-series>
        </kendo-chart> -->
        </div>
        <hr/>

        <div class="row">
          <div class="col">
            <ng-container *ngIf="!event.isWebRTC">
              <div class="btn-group btn-block mb-1" role="group">
                <button id="btnGroupDrop1" type="button" class="btn btn-block btn-sm dropdown-toggle" [ngClass]="{ 'btn-success': dashboard.isChannelRunning, 'btn-instagram': !dashboard.isChannelRunning }" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">{{ event.streamingChannel }}: {{ dashboard.channelStatus }}</button>
                <div class="dropdown-menu" aria-labelledby="btnGroupDrop1">
                  <a *ngIf="!dashboard.isChannelRunning" class="dropdown-item" (click)="startChannel()" href="javascript:void(0);">Start Channel</a>
                  <a *ngIf="dashboard.isChannelRunning" class="dropdown-item" (click)="stopChannel()" href="javascript:void(0);">Stop Channel</a>
                </div>
              </div>
              <div class="btn-group btn-block mb-1" role="group">
                <button *ngIf="dashboard.isIngesting" id="btnGroupDrop1" type="button" class="btn btn-block btn-sm dropdown-toggle" [ngClass]="{ 'btn-success': dashboard.isBroadcastRunning, 'btn-instagram': !dashboard.isBroadcastRunning }" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">Broadcast: {{ dashboard.broadcastStatus }}</button>
                <button *ngIf="!dashboard.isIngesting" [disabled]="true" id="btnGroupDrop1" type="button" class="btn btn-block btn-sm btn-warning">Event: Not Ingesting</button>
                <div class="dropdown-menu" aria-labelledby="btnGroupDrop1">
                  <a *ngIf="!dashboard.isBroadcastRunning && dashboard.isIngesting" class="dropdown-item" (click)="startEvent()" href="javascript:void(0);">Start Broadcast</a>
                  <a *ngIf="dashboard.isBroadcastRunning" class="dropdown-item" (click)="stopEvent()" href="javascript:void(0);">Stop Broadcast</a>
                </div>
              </div>
            </ng-container>
            <div class="btn-group btn-block mb-1" role="group">
              <button id="btnGroupDrop1" type="button" class="btn btn-block btn-sm dropdown-toggle" [ngClass]="{ 'btn-success': event.allowAttendeesOnCamera, 'btn-instagram': !event.allowAttendeesOnCamera }" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">Attendee cameras</button>
              <div class="dropdown-menu" aria-labelledby="btnGroupDrop1">
                <a class="dropdown-item" (click)="allowOnCamera()" href="javascript:void(0);">Allow</a>
                <a class="dropdown-item" (click)="denyOnCamera()" href="javascript:void(0);">Deny</a>
              </div>
            </div>
            <div class="btn-group btn-block mb-1" role="group">
              <button id="btnGroupDrop1" type="button" class="btn btn-github btn-block btn-sm dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">Tokens</button>
              <div class="dropdown-menu" aria-labelledby="btnGroupDrop1">
                <a class="dropdown-item" href="javascript:void(0);" (click)="scheduleTokens()">Schedule Checks</a>
                <a class="dropdown-item" href="javascript:void(0);" (click)="showToken(1)">Show Token 1</a>
                <a class="dropdown-item" href="javascript:void(0);" (click)="showToken(2)">Show Token 2</a>
                <a class="dropdown-item" href="javascript:void(0);" (click)="showToken(3)">Show Token 3</a>
                <a class="dropdown-item" href="javascript:void(0);" (click)="showToken(4)">Show Token 4</a>
              </div>
            </div>
            <ul class="mb-0">
              <li class="mb-1">
                <button type="button" class="btn btn-block btn-sm btn-danger" (click)="resetChatAndQuestions()">Reset Chat & Questions</button>
              </li>
              <li class="mb-1">
                <button type="button" class="btn btn-block btn-sm btn-danger" (click)="resetEvent()">Reset Event</button>
              </li>
              <li class="mb-1">
                <button type="button" class="btn btn-block btn-sm btn-success" (click)="openForCeus()">Open for CEUs</button>
              </li>
            </ul>
          </div>
          <div class="col">
            <button type="button" (click)="rebuildCacheForEvent()" class="btn btn-sm btn-block btn-success mb-1">Rebuild Cache</button>

            <div class="btn-group btn-block mb-1" role="group">
              <button id="btnGroupDrop1" type="button" class="btn btn-github btn-block btn-sm dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">RTMP</button>
              <div class="dropdown-menu" aria-labelledby="btnGroupDrop1">
                <a class="dropdown-item text-success" (click)="startOpenTokRTMP()" href="javascript:void(0);">Start OpenTok RTMP Only</a>
                <a class="dropdown-item text-danger" (click)="stopOpenTokRTMP()" href="javascript:void(0);">Stop OpenTok RTMP Only</a>
              </div>
            </div>

            <div class="btn-group btn-block mb-1" role="group">
              <button id="btnGroupDrop1" type="button" class="btn btn-github btn-block btn-sm dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">Archive</button>
              <div class="dropdown-menu" aria-labelledby="btnGroupDrop1">
                <a class="dropdown-item text-danger" (click)="startOpenTokArchiveOnly()" href="javascript:void(0);">Start OpenTok Archive Only</a>
                <a class="dropdown-item text-success" (click)="startSecondaryOpenTokArchive()" href="javascript:void(0);">Start Secondary Archive</a>
              </div>
            </div>
            <div class="btn-group btn-block mb-1" role="group">
              <button id="btnGroupDrop1" type="button" class="btn btn-danger btn-block btn-sm dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">Failover</button>
              <div class="dropdown-menu" aria-labelledby="btnGroupDrop1">
                <a class="dropdown-item text-danger" (click)="switchToYouTube()" href="javascript:void(0);">Switch to Youtube</a>
                <a class="dropdown-item text-success" (click)="failoverToOpenTok()" href="javascript:void(0);">Failover to Opentok</a>
                <a class="dropdown-item text-success" (click)="startNewLiveOutput()" href="javascript:void(0);">Fix Mobile Audio</a>
              </div>
            </div>

            <button type="button" (click)="startOpenTokStreamOnly()" class="btn btn-block btn-sm btn-danger mb-1">Start OpenTok Stream Only</button>
            <button type="button" (click)="setStreamLayouts()" class="btn btn-sm btn-block btn-danger mb-1">Set Stream Layouts</button>
            <button type="button" (click)="goLive()" class="btn btn-sm btn-block btn-success mb-1">Go Live</button>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Footer -->
  <div class="card-footer d-flex justify-content-end"></div>
  <!-- End Footer -->
</div>
